import { accountExist } from '../GA'
import { track } from '@amplitude/analytics-browser'

export const trackRegistrationAccountExist = () => {
  accountExist()
  return track('account_exist').promise
}
